/** Host (bitzs.site) document meta only. Bit strings live in bit/config/bitSiteMeta.js (separate chunk). */

export const HOST_SITE = {
  title: "bitzs.site | Web Development Studio",
  description:
    "bitzs.site is a Denver-based web studio building marketing sites, online stores, and web apps for U.S. teams.",
  themeColor: "#ffffff",
  robots: "index, follow",
};

function setMetaName(name, content) {
  if (!content) {
    document.querySelector(`meta[name="${name}"]`)?.remove();
    return;
  }

  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

export function applySiteDocument(hostEnabled) {
  if (hostEnabled) {
    document.title = HOST_SITE.title;
    setMetaName("description", HOST_SITE.description);
    setMetaName("theme-color", HOST_SITE.themeColor);
    setMetaName("robots", HOST_SITE.robots);
    setMetaName("googlebot", HOST_SITE.robots);
    return;
  }

  /* Bit mode: block indexing from the main bundle. No crypto copy here. */
  document.title = "Loading…";
  setMetaName("description", "");
  setMetaName("theme-color", "#060d1f");
  setMetaName("robots", "noindex, nofollow");
  setMetaName("googlebot", "noindex, nofollow");
}
